import 'phaser'
import { l } from '../lib/imports'
import { scene } from '../main/scene-sidecar'
import { cargoes } from './cargoes-sidecar'
import { ICargoType } from './cargoesData'
import { stacks } from './stacks-sidecar'

export interface ICargoSaved {
  type: ICargoType
  i: number
  j: number

  isCarried: boolean
  isInStack: boolean
  isInShip: boolean
}

export function save() {
  let sd: ICargoSaved[] = []

  let objs = cargoes.getAll()
  l.forEach(objs, (c) => {
    sd.push({
      i: c.i,
      j: c.j,
      type: c.data.type,
      isCarried: c.carriedBy != null,
      isInStack: c.inStack != null,
      isInShip: c.isInShip,
    })
  })

  return sd
}

export function load(sd: ICargoSaved[]) {
  let ctx = scene.getContext()
  l.forEach(sd, (c) => {
    let obj = cargoes.create(c.type)
    cargoes.moveToTile(obj, ctx.mapShip, c.i, c.j)
    if (c.isCarried) {
      // try to get monster here
      // oh well, drop for now
      // monsters
    }
    obj.isInShip = c.isInShip
    if (c.isInStack) {
      let st = stacks.findAtSpot(c.i, c.j, (d) => d.holdsType === c.type)
      if (st) {
        stacks.addToStack(st, obj)
      }
    }
  })
}
